export interface SignupRequest {
  userAuth0Id: string;
  email: string;
  companyName: string;
  referralSource: string;
  objectives: string;
  existingTicketingSystem?: SignupTicketingSystems;
}

export interface SignupResponse {
  success: boolean;
}

export enum SignupTicketingSystems {
  zendesk = "zendesk",
  salesforce = "salesforce",
  freshdesk = "freshdesk",
  hubspot = "hubspot",
  kustomer = "kustomer",
  monday = "monday",
  front = "front",
  jira = "jira",
  helpscout = "helpscout",
  plain = "plain",
  gorgias = "gorgias",
  apibased = "apibased",
  intercom = "intercom",
}
